module.exports = __webpack_public_path__ + "static/media/zs-img1.d06e9275.png";